module.exports = __webpack_public_path__ + "static/img/map.fd43e01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map.png
// module id = /PMo
// module chunks = 7